module.exports = function () {

    var elements = document.getElementsByClassName('media');
    if (elements.length > 0) {
        for (var i = 0; i < elements.length; i++) {

            var embeds = elements[i].getElementsByTagName('oembed');
            if (embeds.length > 0) {
                for (var j = 0; j < embeds.length; j++) {

                    var embed = embeds[j];
                    var url = embed.getAttribute('url');

                    url = url.split('youtube.com/watch?v=').join('youtube.com/embed/');
                    url = url.split('youtube.com/watch/').join('youtube.com/embed/');

                    elements[i].innerHTML = '<iframe src="' + url + '?origin=' + location.origin + '" style="" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen=""></iframe>';


                    console.log(embeds[i]);
                }
            }

        }
    }

};